import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import {baseAuthUrl, baseUrl} from '../helpers/apiList';

// Create Context
export const BankNameContext = createContext();

export const BankNameProvider = ({ children }) => {
  const [bankNames, setBankNames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBankNameData = async () => {
      try {
        const response = await axios.get(`${baseAuthUrl}/sms/bankname`);
        if(response.data){
          setBankNames(response.data.data);
        } else {
          console.error('Failed to fetch bank list');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBankNameData();
  }, []);

  return (
    <BankNameContext.Provider value={{ bankNames, loading, error }}>
      {children}
    </BankNameContext.Provider>
  );
};
